module.exports = __webpack_public_path__ + "static/media/bgmusic.178ead69.wav";